import React from "react";
import RubyQuickFixesWidget from "./RubyQuickFixesWidget";

interface AskRubyAIReadinessWidgetProps {
  activeTab?: string;
  onIssueFixed?: () => void;
}

const AskRubyAIReadinessWidget: React.FC<AskRubyAIReadinessWidgetProps> = ({
  activeTab = "overview",
  onIssueFixed,
}) => (
  <RubyQuickFixesWidget cardId="ai-readiness" activeTab={activeTab} onIssueFixed={onIssueFixed} />
);

export default AskRubyAIReadinessWidget;
